import React from "react";
import Modal from "react-bootstrap/Modal";
import { Button } from "../../common/Button";

// Helper to capitalize the first letter of each word
const capitalizeWords = (str) =>
  str.replace(/\b\w/g, (char) => char.toUpperCase());

export function CategoryUsedModal({ show, onHide, users }) {
  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Cannot Delete Category</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>This schedule category is currently used by:</p>
        <ul>
          {users.map((u) => (
            <li key={u?.actorId}>
              <strong>{capitalizeWords(u?.actor?.display || "")}</strong>
            </li>
          ))}
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide} title="Close">Close</Button>
      </Modal.Footer>
    </Modal>
  );
}